export default __webpack_public_path__ + "static/media/B758E453-9FBA-4CB4-9599-D90C5655EC59_1_105_c.c99e2ab4.jpeg";